import './VideoDownload.css'
import * as React from 'react';
import TitleWithText from "../../../Components/TitleWithText/TitleWithText";
import {formatBookName} from "../../../Functions/Formatter";
import {Alert, LinearProgress} from "@mui/material";
import {withRouter} from "react-router-dom";
import {isAdmin} from "../../../Functions/Authentication";
import VideoDetailsTable from "./Component/VideoDetailsTable";
import VideoEditButton from "../../../Components/VideoGallery/VideoEditButton";
import BookmarkButton from "../../../Components/BookmarkButton/BookmarkButton";
import {addThis, getSharingUrl} from "../../../Functions/AddThis";
import LinksBar from "../../../Components/LinksBar/LinksBar";
import VideoPlayer from "./Component/VideoPlayer";
import VideoDownloadButton from "./Component/VideoDownloadButton";
import DownloadLimit from "../../../Components/DownloadLimit/DownloadLimit";
import Comments from "../../../Components/Comments/Comments";
import {isAdsEnabled, showAds} from "../../../Functions/Ads";

class VideoDownload extends React.Component {
  state = {
    data: null
  }

  componentDidMount() {
    this.updateBreadcrumbs();
    this.loadVideo();
  }

  loadVideo() {
    fetch('/api/videos/' + this.props.match.params.id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.status.toString())
        }
      })
      .then(data => {
        this.setState({data: data});
        this.updateBreadcrumbs(formatBookName(data.name));
      })
      .catch(error => {
        this.setState({
          data: null,
          errorMessage: error?.message === "404"
            ? "The video you are looking for could not be found."
            : "An unknown error has occurred loading this page, please try again later."
        });
        this.updateBreadcrumbs(error?.message === "404" ? "Not Found" : "Unknown Error");
      });
  }

  updateBreadcrumbs(pageName) {
    const breadcrumbs = pageName ? [{label: pageName, link: "/video/" + this.props.match.params.id}] : [];
    this.props.setBreadcrumbs([{label: "Video", link: "/video/browse/all"}, ...breadcrumbs]);
  }

  getPartNumber() {
    if (this.state?.data?.parts?.length) {
      const queryParams = new URLSearchParams(this.props.location.search);
      const selectedPartNo = queryParams?.get("part") || 0;

      if (selectedPartNo < 0) {
        return 0;
      }

      if (selectedPartNo > this.state.data.parts.length) {
        return this.state.data.parts.length;
      }

      return selectedPartNo;
    }

    return null;
  }

  getPart(partNumber) {
    if (partNumber === null) {
      return null;
    }

    return this.state.data.parts[partNumber];
  }

  render() {
    const partNumber = this.getPartNumber();
    const selectedPart = this.getPart(partNumber);

    return (
      <div className={"video-download-page"}>
        {
          (this.state.data == null && this.state.errorMessage == null) &&
          <LinearProgress/>
        }
        {
          (this.state.data == null && this.state.errorMessage != null) &&
          <React.Fragment>
            <Alert severity="error">{this.state.errorMessage}</Alert>
          </React.Fragment>
        }
        {
          (this.state.data != null && this.state.errorMessage == null) &&
          <div>
            <TitleWithText align="left" title="Video Details" endIcon={isAdmin() && <VideoEditButton className="video-download-edit" videoId={this.state.data.id} onDataChanged={this.loadVideo.bind(this)}/>}>
              <VideoDetailsTable data={this.state.data}/>
            </TitleWithText>
            <TitleWithText align="left" title="Watch Later" style={{marginTop: "2em"}} className={"video-download-watch-later"}>
              <BookmarkButton variant={"button"} itemType="videos" itemId={this.state.data.id} lazyLoad={true}/>
            </TitleWithText>
            <TitleWithText align="left" title="Share" style={{marginTop: "2em"}}>
              <div className="addthis_inline_share_toolbox" data-url={getSharingUrl()}/>
            </TitleWithText>
            {addThis()}
            {
              isAdsEnabled() &&
              <TitleWithText align="left" title="Advertisement" style={{marginTop: "2em"}}>
                {showAds("3348642554")}
              </TitleWithText>
            }
            <TitleWithText align="left" title="Watch Video" style={{marginTop: "2em"}}>
              {
                this.state.data.parts.length > 1 &&
                <LinksBar queryParam="part" links={this.state.data.parts.map((part) => {
                  return {label: `${part.name} (${part.duration})`, value: part.id === 0 ? null : part.id.toString()}
                })}/>
              }
              <VideoPlayer name={this.state.data.name + (this.state.data.parts.length > 1 ? " - " + selectedPart.name : "")} videoId={this.state.data.id} part={partNumber} thumbnail={selectedPart.thumbnail} fileName={selectedPart.fileName} />
              <VideoDownloadButton className="video-download-button" videoId={this.state.data.id} fileName={selectedPart.fileName} part={partNumber} size={selectedPart.size} />
              <DownloadLimit action="watch online or download" mediaType="videos"/>
            </TitleWithText>
            {
              isAdsEnabled() &&
              <TitleWithText align="left" title="Advertisement" style={{marginTop: "2em"}}>
                {showAds("9722479212")}
              </TitleWithText>
            }
            <TitleWithText align="left" title="Comments" style={{marginTop: "2em"}} className={"video-comments-wrapper"}>
              <Comments className={"video-comments"} id={"video-" + this.state.data.id} title={"Video - " + this.state.data.name}/>
            </TitleWithText>
          </div>
        }
      </div>
    );
  }
}

export default withRouter(VideoDownload);
